<script>
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { Col, Row } from "sveltestrap";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import JobsBacklogTable from "../JobsBacklog/JobsBacklogTable.svelte";
	import CustomSelect from "../../../components/CustomSelect/CustomSelect.svelte";
	import SveltyPicker from "svelty-picker";
	import ConfirmModal from "../../../components/CustomModal/ConfirmModal.svelte";
	import { assignableTasks, errorMessage, loading } from "src/store/store";
	import { navigate } from "svelte-routing";
	import client from "src/services/client";
	import { onMount } from "svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { extractErrorMessage, queryArrStrToNum } from "src/utils/misc";
	import queryString from "query-string";
	import CustomSearch from "../../../components/CustomSearch/CustomSearch.svelte";

	export let location;

	let err;
	let isCollapsed = false;
	let assignedTo = "user";
	let createBlackout = true;
	let startDateTime;
	let endDateTime;
	let confirmOpen = false;
	let vehicles = {};
	let taskIds = [];
	let data = [];
	let initData = [];
	let users = [];
	let params = {};
	let lookups = {};

	$: tableData = [];
	$: userOrGroup = { value: "", label: `Select a ${assignedTo}` };

	function toggleCollapse() {
		isCollapsed = !isCollapsed;
		if (isCollapsed) {
			tableData = initData.slice(0, 3);
		} else {
			tableData = initData;
		}
	}

	function handleAssign() {
		confirmOpen = true;
	}

	async function fetchTasks() {
		try {
			loading.set(true);

			params = queryString.parse(window.location.search);
			params.taskIds = queryArrStrToNum(params.taskIds);

			const res = await client("/v1/Tasks/search", {
				method: "POST",
				version: "Tasking",
				data: {
					...params,
					pageSize: 60,
				},
			});

			if (res.status === 200) {
				let data = res.data.data;
				vehicles = res.data.vehicles;
				tableData = data.map((task) => {
					return {
						"Vehicle No.": vehicles[task.vehicleId].plateNumber,
						"Car Status": vehicles[task.vehicleId].statusId,
						Task: task.presetTaskDescription,
						Priority: task?.priority.toString(),
						Bookings: vehicles[task.vehicleId].bookings,
						Region: vehicles[task.vehicleId].region,
						Address: vehicles[task.vehicleId].address,
					};
				});
				initData = tableData;
				loading.set(false);
			}
		} catch (error) {
			loading.set(false);
			console.log(error);
		}
	}

	async function handleSubmit() {
		try {
			let data = {
				backlogTaskIds: params.taskIds,
				start: new Date(startDateTime),
				due: new Date(endDateTime),
				assignee: {},
				createBlackout,
			};
			data.assignee[assignedTo + "id"] = userOrGroup.value;
			const res = await client("/v1/Jobs", {
				method: "POST",
				version: "Tasking",
				data,
			});
			if (res.status === 204) {
				navigate("/jobs?tab=1", { replace: true });
				confirmOpen = false;
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
		}
	}

	async function fetchActiveUsers(e) {
		if (e !== "") {
			try {
				const res = await client("/v0/Auth/GetUsersWithFilter", {
					method: "POST",
					version: "Tasking",
					data: {
						status: 0,
						name: e,
					},
				});
				if (res.status === 200) {
					users = res.data.data.users.map((user) => {
						return {
							value: user.userId,
							label: user.fullName,
						};
					});
					return users;
				}
			} catch (error) {
				console.log(error);
			}
		}
	}

	async function fetchActiveGroups(e) {
		if (e !== "") {
			try {
				const res = await client("/v0/Group/GetWithFilters", {
					method: "POST",
					version: "Tasking",
					data: {
						status: true,
						name: e,
					},
				});
				if (res.status === 200) {
					users = res.data.data.groups.map((group) => {
						return {
							value: group.groupId,
							label: group.name,
						};
					});
					return users;
				}
			} catch (error) {
				console.log(error);
			}
		}
	}

	async function fetchVehicleStatuses() {
		try {
			const res = await client(`/v2/masterDatas/vehicleStatuses`, {
				method: "GET",
				version: "Vehicle",
			});
			if (res.status === 200) {
				lookups.vehicleStatuses = res.data;
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
		}
	}

	onMount(() => {
		fetchTasks();
		fetchVehicleStatuses();
	});

	const modalCopy = {
		user: {
			header: "Create and assign job to user",
			bodyText:
				"This job will be created and assigned to this user. This user can view the job on the Operator app. Are you sure you want to proceed?",
		},
		group: {
			header: "Create and assign job to a group",
			bodyText:
				"This job will be created and assigned to this group. This group can view the job on the Operator app. Are you sure you want to proceed?",
		},
		noBlackout:
			"\nIt also seems that you have set ‘Blackout car after assignment’ as ‘No’. Doing so will require you to manually set a blackout for the cars associated to these jobs. Are you sure you want to proceed?",
	};

	assignableTasks.subscribe((value) => {
		taskIds = value;
	});

	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Row>
				<Col class="row d-flex align-items-start mx-0 px-0">
					<PageHeader title="Assign" />
				</Col>
				<Col class="d-flex flex-row-reverse" style="height: 70px">
					<div class="mx-2">
						<CustomButton
							buttonText="Assign"
							color="primary"
							onClick={handleAssign}
							disabled={!userOrGroup ||
								!startDateTime ||
								!endDateTime}
						/>
					</div>
					<div class="mx-2">
						<CustomButton
							buttonText="Cancel"
							onClick={() => navigate("/jobs?tab=3")}
						/>
					</div>
				</Col>
			</Row>
		</div>
	</Col>
	<Col class="mb-2">
		<b>Step 2: Assign the job to a user/group.</b>
	</Col>
	<div class="section-container">
		<div class="d-flex justify-content-between mb-3">
			<b>Tasks to assign</b>
			<div>
				{#if isCollapsed}
					<div on:click={toggleCollapse} on:keydown={toggleCollapse}>
						<img
							src="/assets/icon-chevron-up.png"
							alt="chevron-up"
							style="width: 18px; height: 18px;"
						/>
					</div>
				{:else}
					<div on:click={toggleCollapse} on:keydown={toggleCollapse}>
						<img
							src="/assets/icon-chevron-down.png"
							alt="chevron-up"
							style="width: 18px; height: 18px;"
						/>
					</div>
				{/if}
			</div>
		</div>
		<LoaderContainer>
			<JobsBacklogTable
				backlogTasks={tableData}
				toggleDetails={() => {}}
				isAssign={true}
				{lookups}
			/>
		</LoaderContainer>
	</div>
	<div class="section-container">
		<div class="mb-3">
			<b>Configuration</b>
		</div>
		<div class="mb-3">
			<span class="mx-1"> Assign this job to </span>
			<div class="my-3">
				<div>
					<label>
						<input
							type="radio"
							name="assign-to"
							id="assign-user"
							value={"user"}
							class="mx-3"
							bind:group={assignedTo}
						/>
						<span>A single user</span>
					</label>
					<label>
						<input
							type="radio"
							name="assign-to"
							id="assign-group"
							value={"group"}
							class="mx-3"
							bind:group={assignedTo}
						/>
						<span>A group</span>
					</label>
				</div>
			</div>
			<div class="my-3">
				<Col xs={3}>
					{#if assignedTo === "user"}
						<span>Select a user</span>
						<CustomSearch
							type="text"
							placeholder="Select a user"
							bind:value={userOrGroup}
							loadOptions={fetchActiveUsers}
						/>
					{:else}
						<span>Select a group</span>
						<CustomSearch
							type="text"
							placeholder="Select a group"
							bind:value={userOrGroup}
							loadOptions={fetchActiveGroups}
						/>
					{/if}
				</Col>
			</div>
			<div class="my-3">
				<Row>
					<Col xs={4}>
						<span>Start date and time</span>
						<SveltyPicker
							inputClasses="form-control getgo input calendar-icon"
							format="yyyy-mm-dd hh:ii"
							placeholder="Select a start date and time"
							bind:value={startDateTime}
						/>
					</Col>

					<Col xs={4}>
						<span> End date and time </span>
						<SveltyPicker
							inputClasses="form-control getgo input calendar-icon"
							format="yyyy-mm-dd hh:ii"
							placeholder="Select an end date and time"
							bind:value={endDateTime}
						/>
					</Col>
				</Row>
			</div>
			<div class="mb-3">
				<span class="mx-1">Blackout car after assignment</span>
				<div class="my-3">
					<div>
						<label>
							<input
								type="radio"
								name="blackout-car"
								id="blackout-yes"
								value={true}
								class="mx-3"
								bind:group={createBlackout}
							/>
							<span>Yes</span>
						</label>
						<label>
							<input
								type="radio"
								name="blackout-car"
								id="blackout-no"
								value={false}
								class="mx-3"
								bind:group={createBlackout}
							/>
							<span>No</span>
						</label>
					</div>
				</div>
			</div>
		</div>
	</div></Row
>
<ConfirmModal
	header={modalCopy[assignedTo].header}
	bodyText={modalCopy[assignedTo].bodyText}
	extraText={createBlackout === false ? modalCopy.noBlackout : ""}
	buttonText="Confirm"
	open={confirmOpen}
	buttonColor="primary"
	outline={false}
	toggle={() => (confirmOpen = false)}
	{handleSubmit}
/>

<style>
	:global(.section-container) {
		border: 1px solid #e8e8e8;
		border-radius: 8px;
		padding: 24px;
		margin: 12px 0;
	}
</style>
